export default "__VITE_ASSET__Cb7oE9Qr__"